<style lang="scss" scoped>
.slideout-container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    pointer-events: none;
    top: 0;
    left: 0;
    z-index: 10000;

    .slideout {
        position: fixed;
        display: flex;
        flex-direction: column;
        width: 720px;
        right: -720px;
        height: 100%;
        opacity: 0;
        top: 0;
        background: #fff;
        box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.3);
        transition: right 0.15s ease-in-out, opacity 0.15s ease-in-out;
        overflow-y: auto;
        overflow-x: hidden;

        @media screen and (max-width: 720px) {
            width: 100%;
            right: -100%;
        }

        .close {
            position: absolute;
            width: 15px;
            height: 15px;
            right: 25px;
            top: 48px;
            cursor: pointer;

            @media screen and (min-width: 768px) {
                right: 45px;
            }

            &:before,
            &:after {
                content: "";
                position: absolute;
                width: 17px;
                height: 2px;
                border-radius: 1px;
                left: 0;
                transform-origin: left;
                transition: background 0.15s ease-in-out;
                @apply bg-dark;
            }

            &:before {
                top: 1px;
                transform: rotate(45deg);
            }

            &:after {
                bottom: 0;
                transform: rotate(-45deg);
            }

            &:hover {
                &:before,
                &:after {
                    @apply bg-green;
                }
            }
        }

        .slideout-content {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
        }
    }
}

body.slideout-active {
    .slideout-container.show {
        pointer-events: all;
        backdrop-filter: saturate(100%) blur(10px);
        background-color: rgba(30,30,30,0.47);

        .slideout {
            right: 0;
            opacity: 1;
        }
    }
}

.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity 0.2s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

<template>
    <div class="slideout-container" @click="toggleSlideout" :class="{ show: show }">
        <div class="slideout" @click.stop>
            <div class="close" @click="toggleSlideout"></div>
            <div class="slideout-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from "@/app";

export default {
    name: "Ui.SlideoutContainer",

    props: {
        name: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            show: false
        };
    },

    created() {
        const self = this;

        bus.$on("slideout", name => {
            if (self.name === name) {
                self.show = true;
            }
        });

        this.$on("close", value => {
            self.toggleSlideout();
        });
    },

    methods: {
        toggleSlideout() {
            this.$root.slideoutIsOpen = !this.$root.slideoutIsOpen;
            this.show = false;
        }
    },

    watch: {
        show() {
            document.getElementsByTagName("body")[0].classList.toggle("slideout-active");
        }
    }
};
</script>
